module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-video-2e88087254f8040234e0ac5e052b58c5.jpg";